import { Tabs } from 'antd'
import TabPane from 'antd/lib/tabs/TabPane'
import CustomModal from 'components/global/CustomModal'
import React, { useState } from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import CheckInOutTab from '../Common/CheckInOutTab'
import HistoryTab from '../Common/HistoryTab'

const DetailedDropout = () => {
  const [tabKey, setTabKey] = useState<string>('1')
  const {
    detailedDropOutModalOpen,
    setDetailedDropOutModalOpen,
    setCheckInOutModalOpen,
    setParticipantData,
  } = eventAttendanceStore(store => ({
    detailedDropOutModalOpen: store.detailedDropOutModalOpen,
    setDetailedDropOutModalOpen: store.setDetailedDropOutModalOpen,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    setParticipantData: store.setParticipantData,
  }))

  const closeModal = () => {
    setParticipantData(null)
    setDetailedDropOutModalOpen(false)
    setCheckInOutModalOpen(true)
  }

  return (
    <>
      <CustomModal
        openModal={detailedDropOutModalOpen}
        isCloseModalCustom
        closeModal={closeModal}
        title="Drop-out details"
        width={1200}
        footer={false}
      >
        <>
          <Tabs className="" defaultActiveKey={tabKey}>
            <TabPane tab="Drop-out" key="1">
              <CheckInOutTab type="drop-out" />
            </TabPane>
            <TabPane tab="History" key="2">
              <HistoryTab />
            </TabPane>
          </Tabs>
        </>
      </CustomModal>
    </>
  )
}

export default DetailedDropout
